import React, {
  FC,
  useEffect,
  useState,
} from 'react';
import styled from 'styled-components';

import { Nullable } from '@/core/interfaces/common';

import { useIsDesktop } from '@/utils/hooks/useIsDesktop';

interface ShowMoreTextProps {
  text: string;
  textWrapper: FC<{ children: Nullable<React.ReactNode> }>;
  maxLength?: number;
}

export const RestText = styled.span<{ $showMore: boolean }>`
  display: ${({ $showMore }) => ($showMore ? 'inline' : 'none')};
`;

export const ButtonWrapper = styled.div<{ $showMore: boolean }>`
  display: flex;
  justify-content: center;
  margin: 8px 0 14px;

  button {
    overflow: visible;
    width: auto;
    margin: 0 0 3px;
    border: none;
    padding: 4px;
    background-color: inherit;
    color: #595959;
    cursor: pointer;

    span {
      display: inline-block;
      margin: 0 0 ${({ $showMore }) => ($showMore ? '0' : '3px')} 5px;
      border: solid black;
      border-width: 0 1px 1px 0;
      padding: 2px;
      transform: rotate(${({ $showMore }) => ($showMore ? '-135deg' : '45deg')});
    }
  }
`;

export const ShowMoreText: FC<ShowMoreTextProps> = ({
  textWrapper: TextWrapper,
  text = '',
  maxLength = 100,
}) => {
  const [
    showMore,
    setShowMore,
  ] = useState<boolean>(false);
  const [
    isDesktop,
    setIsDesktop,
  ] = useState<boolean>(false);
  const isDesktopFromHook = useIsDesktop();

  useEffect(() => {
    setIsDesktop(isDesktopFromHook);
  }, [isDesktopFromHook]);

  return (
    <>
      {isDesktop || text?.length <= maxLength + 3 ?
        (
          <>
            {text}
          </>
        ) :
        (
          <>
            <TextWrapper>
              {`${text.substring(0, maxLength)}...`}
              <RestText $showMore={showMore}>{text.substring(maxLength)}</RestText>
            </TextWrapper>
            <ButtonWrapper $showMore={showMore}>
              <button
                type="button"
                aria-expanded={showMore}
                aria-controls="more-content"
                onClick={() => setShowMore(!showMore)}
              >
                {!showMore ? 'Read more' : 'Hide description'}
                <span />
              </button>
            </ButtonWrapper>
          </>
        )}
    </>
  );
};
